<script lang="ts">
  import { toZonedTime } from "date-fns-tz"
  import { Chart } from "../../components"
  import { getChannelTimeline } from "../../services/endpoints"
  import { format, parseISO, parseJSON } from "date-fns"
  import { TypedTimelineType, type LocationMergedTimeline } from "../../services/models"
  import { ISOFormatString } from "../../utils"
  import { navigateCustomUrl } from "../../utils/navigateCustom"

  export let channelUuid: string;
  export let videoSelection: string;
  export let audioSelection: string;
  export let skipGapSeconds: number;
  export let startTime: string;
  export let endTime: string;

  let series: object[] = []
  let tooltip = {
    formatter: function () {
        return `
          <b>Type: </b>${this.point.timelineType}<br>
          <b>startDateTime: </b>${this.point.startDateTime}<br>
          <b>endDateTime: </b>${this.point.endDateTime}<br>
          <b>duration: </b>${this.point.duration}s<br>
          ----<br>
          <b>Tags: </b>${JSON.stringify(this.point.tags)}<br>
          <b>isValid: </b>${this.point.timelineIsValid}<br>
          <b>maxGapSizeSeconds: </b>${this.point.maxGapSizeSeconds}s<br>
          <b>sumGapSeconds: </b>${this.point.sumGapSeconds}s<br>
          <b>numGaps: </b>${this.point.numGaps}s<br>
        `;
    }
  }

  $: channelUuid, videoSelection, audioSelection,  skipGapSeconds, startTime, endTime, _loadTimeline()

  function _loadTimeline() {
    if(channelUuid) {
      getChannelTimeline(channelUuid, {
        video: videoSelection,
        audio: audioSelection,
        skipGapSeconds: skipGapSeconds,
        startTime: toZonedTime(parseISO(startTime), Intl.DateTimeFormat().resolvedOptions().timeZone),
        endTime: toZonedTime(parseISO(endTime), Intl.DateTimeFormat().resolvedOptions().timeZone)
      }).then(tl => {buildSeries(tl)})
    }
  }

  function buildSeries(timelines: LocationMergedTimeline[]) {
    series = [
      {
        name: "Foobar",
        data: [],
        dataSorting: {
          enabled: true,
        }
      }
    ]

    for(let mergedTimeline of timelines) {
      for(let timeline of mergedTimeline.timeline) {
        series[0].data?.push({
          start: parseJSON(timeline.startDateTime).getTime(),
          end: parseJSON(timeline.endDateTime).getTime(),
          name: `location: <a style="color: blue" href="${navigateCustomUrl("/locations/" + mergedTimeline.locationUuid)}">${mergedTimeline.locationUuid} ${mergedTimeline.isValid ? "✅" : "❌"}</a>`,
          color: timeline.type == TypedTimelineType.GAP ? (mergedTimeline.isValid ? "#99ffa9": "red") : "green",
          tags: mergedTimeline.tags,
          timelineIsValid: mergedTimeline.isValid,
          timelineType: timeline.type,
          startDateTime: format(timeline.startDateTime, ISOFormatString),
          endDateTime: format(timeline.endDateTime, ISOFormatString),
          duration: timeline.durationMs / 1000,
          maxGapSizeSeconds: mergedTimeline.maxGapSizeSeconds,
          sumGapSeconds: mergedTimeline.sumGapSeconds,
          numGaps: mergedTimeline.numGaps
        })
      }
    }
  }

</script>

<Chart title={null} bind:series={series} tooltip={tooltip}></Chart>